import WebSocket from 'ws';
import { warmupAgentCapabilitiesOnConnect } from '../agents/capabilities/warmup-agent-capabilities-on-connect.js';
import { CliSqliteInterrupted, withCliSqliteSync } from '../sqlite/cli-database.js';
import { upsertCliAgentCapabilityCache } from '../sqlite/agent-capability-cache.js';
import type { LogFn } from '../log.js';
import { sendWsMessage } from './create-ws-bridge.js';

export type AgentCapabilitiesReport = {
  agentType: string;
  configOptions: unknown[];
};

export function createAgentCapabilitiesReporter(params: {
  workspaceId: string;
  getWs: () => WebSocket | null;
}): (info: AgentCapabilitiesReport) => void {
  const { workspaceId, getWs } = params;

  return (info) => {
    if (!Array.isArray(info.configOptions) || info.configOptions.length === 0) return;
    setImmediate(() => {
      let changed = false;
      try {
        changed = withCliSqliteSync((db) =>
          upsertCliAgentCapabilityCache(db, {
            workspaceId,
            agentType: info.agentType,
            configOptions: info.configOptions,
          }),
        );
      } catch (e) {
        if (e instanceof CliSqliteInterrupted) return;
        /* ignore sqlite errors */
      }
      if (!changed) return;
      const socket = getWs();
      if (!socket || socket.readyState !== WebSocket.OPEN) return;
      sendWsMessage(socket, {
        type: 'agent_capabilities',
        agentType: info.agentType,
        configOptions: info.configOptions,
      });
    });
  };
}

export function createWarmupAgentCapabilitiesOnConnect(params: {
  workspaceId: string;
  log: LogFn;
  getWs: () => WebSocket | null;
}): () => Promise<void> {
  return async () => {
    await warmupAgentCapabilitiesOnConnect(params);
  };
}
